/**
 * Die wählbaren Punktwerte beim Setzen von Hand, in Spalten je ganzem Punkt — die ganzen oben,
 * die Zwischenwerte darunter, so bleibt die Reihe der ganzen Zahlen lesbar.
 *
 * `schritt`: die Schrittweite der Aufgabe (Relay `pointsStep`) oder — ohne sie — `0.5` bzw.
 * `1` aus der Einstellung halbe/ganze Punkte. Ein Schritt über 1 (`2`) gibt eine Spalte je
 * Wert. Die Höchstpunktzahl ist immer wählbar, auch wenn sie nicht auf dem Raster liegt.
 */
export function punkteRaster(max: number, schritt: number): number[][] {
  const s = Number.isFinite(schritt) && schritt > 0 ? schritt : 1;
  const werte: number[] = [];
  // Ganzzahlig zählen und dann teilen: 0.1 + 0.2 ≠ 0.3.
  for (let k = 0; k * s <= max + 1e-9; k += 1) werte.push(Math.round(k * s * 1e6) / 1e6);
  if (Math.abs(werte[werte.length - 1] - max) > 1e-9) werte.push(max);

  const spalten = new Map<number, number[]>();
  for (const w of werte) {
    const spalte = s >= 1 ? w : Math.floor(w + 1e-9);
    const liste = spalten.get(spalte);
    if (liste) liste.push(w);
    else spalten.set(spalte, [w]);
  }
  return [...spalten.values()];
}
